import { ResponseMeta } from 'lib/types'
import { MergeWarningData } from './config'

export const MERGE_WARNING_PREFIX = 'MERGE_WARNING:'

export const getMergeWarning = (
  apiMessages: ResponseMeta['messages']
): string | null => {
  if (!apiMessages || apiMessages?.length === 0) return null

  const messages = apiMessages.map((m) => m.detail)

  return (
    messages.find((message) => message.startsWith(MERGE_WARNING_PREFIX)) ?? null
  )
}

export const parseMergeWarningData = (raw: string): MergeWarningData | null => {
  try {
    const mergeWarning = raw.slice(MERGE_WARNING_PREFIX.length)
    const parsed = JSON.parse(mergeWarning)

    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      typeof parsed.contactId === 'number' &&
      typeof parsed.name === 'string' &&
      typeof parsed.email === 'string'
    ) {
      return parsed
    }

    return null
  } catch {
    return null
  }
}
